export const getFormattedColumns = (searchColumns: any[] | undefined) => {
  return (
    searchColumns?.map(col => ({
      field: col.field,
      headerName: col.headerName || col.field,
      flex: col.flex || 1,
      width: col.width || 150,
      renderCell:
        col.renderCell ||
        (col.checkboxSelection
          ? (params: any) => (
              <input
                type='checkbox'
                checked={params.value === true || params.value === 1}
                disabled
                className='size-4 cursor-default'
              />
            )
          : undefined),
      type: col.type || 'string'
    })) || []
  );
};
